export default __webpack_public_path__ + "static/media/check_active.9946de85.svg";